import type { ReactNode } from 'react'
import { Card } from './Card'

type IconTone = 'ink' | 'leaf' | 'mustard' | 'flame'

const ICON_TONE: Record<IconTone, string> = {
  ink: 'bg-ink-tint text-ink',
  leaf: 'bg-leaf-tint text-leaf-deep',
  mustard: 'bg-mustard-tint text-mustard-deep',
  flame: 'bg-flame-tint text-flame-deep',
}

// `emphasis` reserves the flame treatment (border + number) for the 'At risk' stat.
export function StatCard({
  icon,
  tone = 'ink',
  value,
  label,
  caption,
  emphasis = false,
}: {
  icon: ReactNode
  tone?: IconTone
  value: number | string
  label: string
  caption?: ReactNode
  emphasis?: boolean
}) {
  return (
    <Card className={`p-4 ${emphasis ? 'border-[1.5px] border-flame bg-flame-tint/25' : ''}`}>
      <div className={`flex h-9 w-9 items-center justify-center rounded-xl ${ICON_TONE[tone]}`}>{icon}</div>
      <div className={`mt-3.5 font-display text-4xl leading-none ${emphasis ? 'text-flame-deep' : 'text-ink'}`}>{value}</div>
      <div className="mt-1 text-sm font-semibold text-ink-soft">{label}</div>
      {caption && <div className="mt-2 text-xs font-bold text-ink-faint">{caption}</div>}
    </Card>
  )
}
